import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FeatureHelperService } from "../feature-helper/feature-helper.service";
import { TimelineSection } from "../../_models/timeline-models/section-listing.model";
import { TimelineSectionStatus } from "../../_models/timeline-models/timeline-section-status.enum";

@Injectable({ providedIn: 'root' })
export class LearningSectionFlowControlHelperService {

  constructor(private readonly featureHelperService: FeatureHelperService, public dialog: MatDialog) {

  }

  public CanEditTimelineSection(timelineSection: TimelineSection): boolean {
    if (!timelineSection) {
      return false;
    }
    return (timelineSection.status === TimelineSectionStatus.New ||
      timelineSection.status === TimelineSectionStatus.Saved ||
      timelineSection.status === TimelineSectionStatus.Rejected) &&
      (this.featureHelperService.hasFeature('IndividualLearningReportsSave') ||
        this.featureHelperService.hasFeature('IndividualLearningReportsEdit'));
  }
}
